<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
                <h2 class="form-title text-center">
                  Please Complete the Following Two Forms to Process Your Coverage
                </h2>
            </article>
            <article class="d-flex flex-column align-items-center input-section form-section">
              <div class="w-100">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <p v-if="rxApplication.customer.state == 'NY' || rxApplication.customer.state == 'CT' || rxApplication.customer.state == 'MA' || rxApplication.customer.state == 'AK'"
                       class="font-weight-bold mb-0">Accelerant Specialty Insurance Company</p>
                    <p v-else
                       class="font-weight-bold mb-0">Accelerant National Insurance Company</p>
                  </div>
                </div>
              </div>
              <h5 class="font-weight-bold mb-0">Real Estate Professionals</h5>
              <h5 class="font-weight-bold mb-4">Errors and Omissions Insurance Application</h5>
              <h5 class="font-weight-bold">Reliance on a Competitor's Application</h5>
            </article>

            <article class="input-section form-section">
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Name:
                    </label>
                    <input
                        type="text"
                        name="firmName"
                        :value="rxApplication.applicantFirmName"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmName')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmName') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Address:
                    </label>
                    <input
                        type="text"
                        name="firmAddress"
                        :value="rxApplication.customer.address"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmAddress')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmAddress') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="firmCity"
                        v-model="rxApplication.customer.city"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmCity')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmCity') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <input
                        type="text"
                        name="firmState"
                        :value="states[rxApplication.customer.state]"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmState')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmState') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Zip:
                    </label>
                    <input
                        type="text"
                        name="firmZipCode"
                        :value="rxApplication.customer.zipCode"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmZipCode')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmZipCode') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <h4 class="mb-4">
                Re: Application for Real Estate Professionals Errors & Omissions Insurance
              </h4>
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Application:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                          type="text"
                          value="OREP"
                          class="orep-text-input w-100"
                          disabled
                      >
                      <label for class="orep-label mt-2">
                        (Name of Carrier/Professional Liability Program)
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date Application Signed:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                          type="date"
                          class="orep-text-input w-100 text-center"
                          :value="formattedCurrentDate()"
                          disabled
                      >
                      <label for class="orep-label mt-2">
                        (Day/Month/Year)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div >
                <p class="mb-3">
                  This document acknowledges receipt of your firm's request for a Real Estate Professionals Errors & Omissions Policy.
                </p>
                <p class="mb-3">
                  Your firm's request for coverage included the application referenced above.
                </p>
                <p class="mb-2">
                  In lieu of requiring your firm to complete our application, we are willing to use the submitted application subject to the following:
                </p>
                <ol type="i" class="mb-3">
                  <li>
                    You agree that we may use the information contained in such application and any attachments to such application in underwriting your account;
                  </li>
                  <li>
                    We may rely upon the truth and accuracy of the representations contained in said application and the attachments to such application;
                  </li>
                  <li>
                    You hereby represent that the statements and information contained in said application and the attachments to
                    such application are true and accurate to the best of your present knowledge; and
                  </li>
                  <li>
                    Said application, along with this letter, will be deemed attached to and incorporated into any policy we may issue
                    pursuant to it.
                  </li>
                </ol>
                <p class="mb-3">
                  Additionally, you are not aware of any claims and/or circumstances, acts, errors or omissions that could result in a
                  professional liability claim since completion of your application signed on {{ formattedCurrentDate() }}.
                </p>
                <p class="mb-3" v-show="this.rxApplication.customer.state === 'FL'">
                  <strong>Fraud Warning:</strong> Any person who knowingly and with intent to injure, defraud or deceive any insurer files a statement of
                  claim or an application containing any false, incomplete or misleading information is guilty of a felony of the third degree.
                </p>
                <p class="mb-3">
                  Your signature below represents your acceptance of the above provisions.
                </p>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        v-model="rxApplication.name"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('name')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('name') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Title
                    </label>
                    <input
                        type="text"
                        name="title"
                        v-model="rxApplication.title"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('title')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('title') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Signature:
                    </label>
                    <input
                        type="text"
                        name="appSignature"
                        placeholder="Type Your Name to Sign"
                        class="orep-text-input w-100"
                        v-model="rxApplication.appSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('appSignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('appSignature') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date:
                    </label>
                    <input
                        type="date"
                        class="orep-text-input w-100 text-center"
                        :value="formattedCurrentDate()"
                        disabled
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <span v-if="rxApplication.customer.state == 'NY' || rxApplication.customer.state == 'CT' || rxApplication.customer.state == 'MA' || rxApplication.customer.state == 'AK'"
                        class="font-weight-bold">S APP 40006 04 22</span>
                  <span v-else
                        class="font-weight-bold">N APP 40006 09 23</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rx-application-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('rx-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-5')"></button>
              <span class="pagination-dots pagination-current"></span>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid|| !state.pageSixIsValid">
              </button>
            </article>
            <button
                type="submit"
                :disabled="!state.pageSixIsValid"
                :class="{submitDisabled: !state.pageSixIsValid}"
                class="next-btn mont spaced pull-right"
                @click="next()"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import { STATES } from "../../utils/constants";

export default {
  name: "rx-application-5",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    rxApplication() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    next() {
      this.$router.push({
        name: "rx-application-7"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    formattedCurrentDate() {
      return moment(this.rxApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>